// extracted by css-extract-rspack-plugin
export default {"MultiSelectWrapper":"HY6nN","MultiSelectPillsList":"jxy7g","MultiSelectPill":"evZP8","MultiSelectPillRemove":"d2DmT","MultiSelectInputField":"CNt7p","MultiSelectInput":"D88EN"};